import { Component, Vue } from "vue-property-decorator";
import { IClient } from "@/models/clients";

@Component
export default class ClientMixin extends Vue {
  // Methods
  public getClientName({
    client,
    clientId,
    orEmail = false
  }: {
    client?: IClient | null;
    clientId?: IClient["id"] | null;
    orEmail?: boolean;
  }) {
    const _ = this.$_;
    clientId = _.get(client, "id", clientId);
    return _.first(
      _.compact([
        _.trim(_.get(client, "fullname", "")),
        orEmail ? _.trim(_.get(client, "email", "")) : null,
        _.get(client, "is_guest") ? this.$i18n.t("_.guest_client") : "",
        _.isEmpty(client) && clientId
          ? this.$i18n.t("_.deleted_client")
          : this.$i18n.t("_.guest")
      ])
    );
  }
}
